class StateLoader {
  constructor(id) {
    this.key = `state:${id}`;
  }

  loadState(defaultState) {
    try {
      const sessionStorage = typeof window !== 'undefined' && window.sessionStorage;
      let serializedState = sessionStorage && sessionStorage.getItem(this.key);
      return serializedState ? JSON.parse(serializedState) : defaultState;
    } catch (err) {
      return defaultState;
    }
  }

  saveState(state) {
    try {
      const sessionStorage = typeof window !== 'undefined' && window.sessionStorage;
      let serializedState = JSON.stringify(state);
      sessionStorage && sessionStorage.setItem(this.key, serializedState);
    } catch (err) {}
  }
}

export default StateLoader;



// WEBPACK FOOTER //
// ./src/redux/StateLoader.js